import React, { useState,useEffect,useContext,useRef } from "react";
import { useNavigate ,Link } from 'react-router-dom';

import PopopGenerico from '../popup/popupGenerico';
import Spinner from '../spinner/spinner';
import Lang from '../lang/translations';
import helpers from "../_helpers/helpersFunction";
import Context from '../context/context';
import Resizer from 'react-image-file-resizer';
import { set, useForm  } from 'react-hook-form';
import FormCities from '../form/formSelectCity'
import { not } from "ajv/dist/compile/codegen";
import { attivaPush, disattivaPush, pushAttivo } from "../firebase/attivaPush";


const config = require("../_helpers/configServizi"); 

export default function PopupNotifica(props) {
	
	//popup states
	const [modalShow, setModalShow] = useState(false);
	const [provenienza, setProvenienza] = useState("");
	const [contenuto, setContenuto] = useState({});
	const [image, setImage] = useState([]);
	const [alert, setAlert] = useState({display:"displayOff"});
	
	const { register, handleSubmit, control  } = useForm();

	const [userInfo, setUserinfo] = useState({});


	const [username, setUsername] = useState();
	const [eta, setEta] = useState();
	const [sesso, setSesso] = useState();
	const [cerco, setCerco] = useState();
	const [descrizione, setDescrizione] = useState();
	const [cosa_cerco, setCosa_cerco] = useState();
	const [citta, setCitta] = useState();
	
	const inserisciEmail = Lang( {"w": "inserisci_email","page": "profilo"} );
	
	const inserisciUsername = Lang( {"w": "inserisci_username","page": "profilo", "var":true} );

	const uomo = Lang( {"w": "uomo","page": "profilo"} );
	const donna = Lang( {"w": "donna","page": "profilo"} );
	const salva = Lang( {"w": "salva","page": "profilo","var":true} );
	const scegli = Lang( {"w": "scegli","page": "profilo"} );
	const grandezzaFile = Lang( {"w": "grandezza_file","page": "profilo"} );
	const tipologiaFile = Lang( {"w": "solo_immagini","page": "profilo"} );
	const fotoNonConforme = Lang( {"w": "foto_non_conforme","page": "profilo"} );
	const [regioni, setRegioni] = useState({});
	const [showSubMenuProfilo, setShowSubMenuProfilo] = useState(false);
	const [showSubMenuRicevute, setShowSubMenuRicevute] = useState(false);
	const [showSubMenuNotifiche, setShowSubMenuNotifiche] = useState(new URLSearchParams(window.location.search).get("sezione") === "notifiche");	// Sottomenu aperto se url contiene ?sezione=notifiche -> per tracking mod
	const [showSubMenuSupporto, setShowSubMenuSupporto] = useState(false);
	const [scaricaLoading, setScaricaLoading] = useState(false);
	const [uploadLoading, setUploadLoading] = useState(false);
	const [statoprofilo, setStatoprofilo] = useState(false);

	const  context = useContext(Context)

	const queryParams = "?uid=" + context.user_info.clickid + "&email=" + context.user_info.email + "&ref=web"

	const [notifiche, setNotifiche] = useState({
		email: false,
		email_tracking: true,
		telegram: false,
		notifiche_push:false
	});

	// lo switch push riflette lo stato reale di questo browser (permesso + subscription), non un default
	useEffect(() => {
		pushAttivo().then(attivo => setNotifiche(prev => ({ ...prev, notifiche_push: attivo })));
	},[]);

	const sezioneNotificheRef = useRef(null);

	useEffect(() => {
		if(showSubMenuNotifiche) sezioneNotificheRef.current?.scrollIntoView({block:"center"});
	},[]);


	const domain = window.location.hostname;
	

	const anni = () => { var k=[];for(var i=18;i<90;i++){ k.push(i) } return k}
	const [selectAnni, setSelectAnni] = useState(anni());

	let navigate = useNavigate();

	function showPopup(){
		setContenuto({header:Lang( {"w": "header_disiscrizione","page": "profilo"} ),title:Lang( {"w": "titolo_disiscrizione","page": "profilo"} ),descrizione:Lang( {"w": "descrizione_disiscrizione","page": "profilo"} )})
		setProvenienza("unsubscribe");
		setModalShow(true);
	}


	async function unsub(){
		setModalShow(false);
		var formData = {}
        formData.clickid = localStorage.getItem("trackerId")
		
		const response = await helpers.unsubUser(formData)
		if(response.status === "ok") {
			setProvenienza("");
			setContenuto({header:"",title:Lang( {"w": "disiscrizione_ok","page": "profilo"} ),descrizione:""})
			setModalShow(true);
			context.setPremiumLevel(1)
			setTimeout(function(){ window.location.reload();  }, 6000);
		}else{
			setProvenienza("");
			setContenuto({header:"",title:Lang( {"w": "disiscrizione_ko","page": "profilo"} ),descrizione:""})
			setModalShow(true);
		}
	}


	function Sono(){
		
		if(userInfo.sono == "uomo"){
			return (<select  name="sono" data-attribute="sono"  onChange={(e) => handleInputChange(e)}>
				<option  value="uomo">{uomo}</option>
				<option  value="donna">{donna}</option>
			</select>)
		}
		else if(userInfo.sono == "donna"){
			return (<select name="sono" data-attribute="sono"  onChange={(e) => handleInputChange(e)}>
				<option  value="donna">{donna}</option>
				<option  value="uomo">{uomo}</option>
			</select>)
		}else{
			return (<select  name="sono" data-attribute="sono"  onChange={(e) => handleInputChange(e)}>
				<option value="" disabled selected>{scegli}</option>
				<option  value="uomo">{uomo}</option>
				<option  value="donna">{donna}</option>
			</select>);
		}
	}
	
	
	function Cerco(){
		
		if(userInfo.cerco == "uomo"){
			return (<select   name="cerco"  data-attribute="cerco"  onChange={(e) => handleInputChange(e)}>
				<option  value="uomo">{uomo}</option>
				<option  value="donna">{donna}</option>
			</select>)
		}
		else if(userInfo.cerco == "donna"){
			return (<select   name="cerco" data-attribute="cerco"  onChange={(e) => handleInputChange(e)}>
				<option  value="donna">{donna}</option>
				<option  value="uomo">{uomo}</option>
			</select>)
		}else{
			return (<select  name="cerco" data-attribute="cerco"  onChange={(e) => handleInputChange(e)}>
				<option value="" disabled selected>{scegli}</option>
				<option  value="donna">{donna}</option>
				<option  value="uomo">{uomo}</option>
			</select>);
		}
	}

	function popupDisattivaProfilo(){
		setProvenienza("disattiva_profilo");
		setContenuto({header:Lang( {"w": "sei_sicuro_disattiva_profilo","page": "profilo"} ),title:Lang( {"w": "spiegazione-disattiva_profilo","page": "profilo"} ),descrizione:"",bottoni:[{testo:Lang( {"w": "si","page": "profilo","var":true} ),data:"procedi"},{testo:Lang( {"w": "no","page": "profilo","var":true} ),data:"annulla"}]})
		setModalShow(true);
	}

	async function disattivaProfilo(){
		var token = localStorage.getItem('token')
		var trackerId = localStorage.getItem('trackerId')

		var data = {
			clickid: trackerId
		}

	
		fetch(process.env.REACT_APP_APIADDRESS+"/users/disableProfile", {
			method: 'post',
			headers: {
			  'Accept': 'application/json, text/plain, */*',
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer '+ token
			},
			body: JSON.stringify(data)
			})
			.then(response => response.json()) 
			.then(res => {
				console.log(res);
				setProvenienza("");
				setContenuto({header:"",title:Lang( {"w": "disattiva_profilo_ok","page": "profilo"} ),descrizione:"",bottoni:[{testo:Lang( {"w": "torna_home","page": "profilo"} )}]})
				setModalShow(true);
				localStorage.clear();
				setTimeout(function(){ window.location.reload();  }, 5000);
				
		});

		if(context.premiumLevel > 1){
			var formData = {}
        	formData.clickid = localStorage.getItem("trackerId")
			await helpers.unsubUser(formData)
		}
		
	}

	async function changeNotificationPreferences(data) {
		
		var token = localStorage.getItem('token')
		var trackerId = localStorage.getItem('trackerId')

		data.clickid = trackerId;

		fetch(process.env.REACT_APP_APIADDRESS+"/users/changeNotificationPreferences", {
			method: 'post',
			headers: {
			  'Accept': 'application/json, text/plain, */*',
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer '+ token
			},
			body: JSON.stringify(data)
			})
			.then(response => response.json()) 
			.then(res => {
				console.log(res);
			})
				
	}


	function UpdateUser(e) {
		
		var token = localStorage.getItem('token')
		var trackerId = localStorage.getItem('trackerId')

		helpers.kpiPanel(context, null, null, true, null, { canon:"bio", dedup:true})

		e.preventDefault();
		var data = {}

		data.eta = eta
		data.username = username
		data.sono = sesso
		data.cerco = cerco
		data.descrizione = descrizione
		data.cosa_cerco = cosa_cerco
		data.servizio = window.location.hostname;
	

		fetch(process.env.REACT_APP_APIADDRESS+"/users/"+trackerId, {
			method: 'put',
			headers: {
			  'Accept': 'application/json, text/plain, */*',
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer '+ token
			},
			body: JSON.stringify(data)
			})
			.then(response => response.json()) 
			.then(res => {
				console.log(res);
				if(!res.result){
					const mailEsistente = Lang( {"w": "mail_esistente","page": "profilo"} );
					const selezionaAltra = Lang( {"w": "seleziona_altra_mail","page": "profilo"} );
					context.setTooltip({visible:true,title:mailEsistente,text:selezionaAltra,variant:"danger",autoClose:true})
				}else{
					const titolo_ok = Lang( {"w": "titolo_ok","page": "profilo"} );
					const testo_ok = Lang( {"w": "testo_ok","page": "profilo"} );
					context.setTooltip({visible:true,title:titolo_ok,text:testo_ok,variant:"success",autoClose:true})
					if(data.cerco){
						window.location.reload();
					}
				}
				
		});
	}


	async function UpdatePhoto(file) {
		setUploadLoading(true);
		try {
			const result = await helpers.uploadFotoProfilo(file, context.flusso?.moderazione_foto);
			if (result.status === 'invalid_type') {
				setAlert({ display: "displayOn", message: tipologiaFile });
			} else if (result.status === 'rejected') {
				setAlert({ display: "displayOn", message: fotoNonConforme });
			} else if (result.status === 'error') {
				setAlert({ display: "displayOn", message: grandezzaFile });
			} else {
				setImage(result.data);
				setAlert({ display: "displayOff" });
				window.location.reload();
			}
		} finally {
			setUploadLoading(false);
		}
	}


	useEffect(() => {
		
		if(context.user_info){
			//imposto setNotifiche la key email con il valore di context.userInfo
			setNotifiche(prev => ({ ...prev, email: context.user_info.email_score > 0 ? true : false, email_tracking: context.user_info.email_info?.email_tracking !== false }));

		}
	},[context.user_info]);


	useEffect(() => {
		var trackerId = localStorage.getItem('trackerId')
		var token = localStorage.getItem('token')
		
		fetch(process.env.REACT_APP_APIADDRESS+"/users/profile/"+trackerId,{ 
			method: 'get', 
			headers: {
				'Authorization': 'Bearer '+ token
			}
		})
		.then(response => response.json()) 
		.then(data => {
			setUserinfo(data);
			
			if(data.imageName){
				setImage(ordinaFotoPredefinita(data.imageName));
			}else{
				setImage([]);
			}
			
		});

		helpers.getRegionsByCountry()
		.then(res => {
			setRegioni(res)
		})
	},[]); 



	function ordinaFotoPredefinita(foto){
		var fotoOrdinate = []
		if(foto.length == 0){
			return fotoOrdinate
		}
		foto.map(el=>{
			if(el.predefinita){
				fotoOrdinate.unshift(el)
			}else{
				fotoOrdinate.push(el)
			}
		})
		return fotoOrdinate
	}


	function handleInputChange(target) {



		if(target && target.currentTarget){
			const value = target.currentTarget.value;
			
			
			
			if (target.currentTarget.name === "username") {
				setUsername(target.currentTarget.value)
				setUserinfo({...userInfo, username:target.currentTarget.value})
			}

			if (target.currentTarget.name === "eta") {
				setEta(target.currentTarget.value)
				setUserinfo({...userInfo,eta:target.currentTarget.value})
			}

			if (target.currentTarget.name === "sono") {
				setSesso(target.currentTarget.value)
				setUserinfo({...userInfo, sono:target.currentTarget.value})
			}

			if (target.currentTarget.name === "cerco") {
				setCerco(target.currentTarget.value)
				setUserinfo({...userInfo, cerco:target.currentTarget.value})
			}

			if (target.currentTarget.name === "descrizione") {
				setDescrizione(target.currentTarget.value)
				setUserinfo({...userInfo, descrizione:target.currentTarget.value})
			}

			if (target.currentTarget.name === "cosa_cerco") {
				setCosa_cerco(target.currentTarget.value)
				setUserinfo({...userInfo, cosa_cerco:target.currentTarget.value})
			}
		}
				

		
	}



	async function scaricaRicevuta(id){
		setScaricaLoading(true);
		var token = localStorage.getItem('token')
		
		fetch(process.env.REACT_APP_APIADDRESS+"/legal/get_receipt/"+id,{ 
			method: 'get', 
			headers: {
			  'Authorization': 'Bearer '+ token
			}
		})
		.then(data => {
			//scarico il pdf di risposta
			if(data.status === 200){
				data.blob().then(blob => {
					const url = window.URL.createObjectURL(new Blob([blob]));
					const a = document.createElement('a');
					a.href = url;
					a.download = "ricevuta_"+id+".pdf";
					document.body.appendChild(a);
					a.click();
					a.remove();
					setScaricaLoading(false);
				});
			}else {
            setScaricaLoading(false);
			}
			
			
		})
		.catch(() => setScaricaLoading(false));

	}


	function handleSwitch(notificaKey) {
    setNotifiche(prev => {
        const nuovoValore = !prev[notificaKey];
        // Aggiorna lo stato PRIMA di chiamare la funzione che salva la preferenza
        const nuoveNotifiche = { ...prev, [notificaKey]: nuovoValore };
        switch(notificaKey) {
            case 'email':
                changeNotificationPreferences({ email: nuovoValore });
                break;

			case 'email_tracking':
				changeNotificationPreferences({ email_tracking: nuovoValore });
				break;

            case 'telegram':
				console.log("Preferenza Telegram cambiata:", nuovoValore);
                if(nuovoValore){
					window.location.href = "tg:resolve?domain="+config.servizi[window.location.hostname].nome_bot
					+"&start=" + localStorage.getItem("trackerId");
				}
                break;

            case 'notifiche_push':
				if(nuovoValore){
					attivaPush().then((esito) => {
						// permesso negato o push non disponibili: lo switch torna spento
						if(esito !== 'ok'){
							setNotifiche(prev => ({ ...prev, notifiche_push: false }));
						}
					});
				} else {
					disattivaPush().then((esito) => {
						// il token non e' stato tolto: le push continuano ad arrivare, lo switch torna acceso
						if(esito !== 'ok'){
							setNotifiche(prev => ({ ...prev, notifiche_push: true }));
						}
					});
				}
                break;

            default:
                console.warn("Preferenza sconosciuta:", notificaKey);
                break;
        }
        return nuoveNotifiche;
    });
}
	
	
	return (<div className="container filters-padding profilepage" style={{paddingBottom:"100px"}}>
				<form onSubmit={UpdateUser}>
				<div className="container filters-no-padding" role="main">
					
					<div class="fos_user_user_show row">	
						<div className="col-12 col-md-6 col-lg-4 p-0 rounded">
							<div className="image_profile rounded">
							{image.length > 0 && (
								
								<div className="cambiafoto"> 
									<label>
										<object 
											data={image[0].path.startsWith('http')
												? image[0].path
												: config.servizi[window.location.hostname].url_foto_utente + "/uploads/" + image[0].path
											}
											type="image/png"
										>
											<img key={(new Date()).getTime()} className="card-img-top rounded" src={userInfo.sono == "uomo" ? "/img/avatar-uomo.jpg" : "/img/avatar-donna.jpg"} alt="Card image cap"/>
										</object>
										<span class="input-group-text bottoneCambia"><i className="fa fa-plus mr-2"></i> <Lang w={"cambia_foto"} page={"profilo"}/></span>
										<input style={{display:`none`}} type="file" id="file" className="inputfile"   onChange={(e)=>UpdatePhoto(e.target.files)}/>
									</label>
								</div>
							)}
							{image.length == 0 && ( 
								<div className="cambiafoto"> 	
									<label>
										<img className="card-img-top rounded" src={userInfo.sono == "uomo" ? "/img/avatar-uomo.jpg" : "/img/avatar-donna.jpg"} alt="Card image cap"/>
										<span class="input-group-text bottoneCambia"><i className="fa fa-plus mr-2"></i> <Lang w={"cambia_foto"} page={"profilo"}/></span>
										<input style={{display:`none`}} type="file" id="file" className="inputfile"  onChange={(e)=>UpdatePhoto(e.target.files)}
										/>
									</label>
								</div>
							)}
							</div>
							<div class="px-3 no-gutters">
								<ul className="list-group list-group-flush">
									<li className="list-group-item">
										
										<div class="input-group">
											{(context.premiumLevel > 0 && context.fluxId !== "0000") ? (
												<li className="list-group-item pb-1">
													<i class="fas fa-coins mr-2"></i>
													<label><strong> <Lang w={"crediti_messaggi"} page={"profilo"}/></strong></label>
													<input type="text"  className="form-control" value={context.creditiMessaggi} disabled></input> 
													<div class="input-group-append">
														<span onClick={() => { navigate({pathname: '/vip_plan/cred'})}} class="input-group-text"><Lang w={"aggiungi"} page={"profilo"}/></span>
														
													</div>
												</li>) : (<></>)}
											
										</div>
									</li>
									
								</ul>
								
							</div>
							
							<div class={alert.display + " alert alert-danger"} role="alert">
								{alert.message}
							</div>
							
						</div>

						<div class="col-12 col-md-6 col-lg-8 pl-md-3">
							<div class="row px-3 no-gutters">
								<ul className="list-group list-group-flush">
										<li className="list-group-item pb-1">
											<i className="fa fa-user mr-2"></i>
												<label><strong><Lang w={"username"} page={"profilo"}/>: </strong></label><input type="text" data-attribute="username" name="username"  value={userInfo.username} placeholder={inserisciUsername}  onChange={(e) => handleInputChange(e)}></input> 
										</li>
										
										<li className="list-group-item">
											<i className="fa fa-envelope mr-2"></i> 
											<label><strong><Lang w={"email"}  page={"profilo"}/>:</strong></label><input type="text" name="email" placeholder={inserisciEmail} data-attribute="email" disabled value={userInfo.email}></input>
										</li>
										<li className="list-group-item">
											<i class="fas fa-birthday-cake mr-2"></i>
											<label><strong><Lang w={"eta"} page={"profilo"}/>:</strong></label>
											<select name="eta"  onChange={(e) => handleInputChange(e)}>
												<option selected>{userInfo.eta}</option>
												{
													selectAnni.map(el=>(
														<option value={el}>{el}</option>
													 ))
												}
											</select>
										</li>
										{/*<li className="list-group-item">
											<i className="fas fa-venus-mars mr-2"></i> 
											<label><strong><Lang w={"sono"} page={"profilo"}/>:</strong></label>
											<Sono/>
										</li>

										<li className="list-group-item">
											<i className="fas fa-search mr-2"></i> 
											<label><strong><Lang w={"cerco"} page={"profilo"}/>:</strong></label>
											<Cerco/>
										</li>*/}

										<li className="list-group-item">
											<i className="fa fa-align-left mr-2"></i> 
											<label><strong><Lang w={"descrizione"} page={"profilo"}/>:</strong></label>
											<textarea data-attribute="descrizione"  name="descrizione" value={userInfo.descrizione} onChange={(e) => handleInputChange(e)}></textarea>
										</li>

										<li className="list-group-item">
											<i className="fas fa-search mr-2"></i> 
											<label><strong><Lang w={"cosa_cerco"} page={"profilo"}/>:</strong></label>
											<textarea data-attribute="cosa_cerco"  name="cosa_cerco" value={userInfo.cosa_cerco}  onChange={(e) => handleInputChange(e)} ></textarea>
										</li>
										
										
										{
											context.fluxId != "0000" && (
												<li className="list-group-item">
													<i className="fas fa-map-marker-alt mr-2"></i> 
													<label><strong><Lang w={"scegli_citta"} page={"profilo"}/>:</strong></label>
													<FormCities  onChange={(e) => handleInputChange(e)}/>
												</li>
											)
										}

										<hr/>

										<li className="list-group-item" style={{cursor: "pointer", marginBottom:"30px"}}>
											<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
												<path fill-rule="evenodd" clip-rule="evenodd" d="M14.2788 2.15224C13.9085 2 13.439 2 12.5 2C11.561 2 11.0915 2 10.7212 2.15224C10.2274 2.35523 9.83509 2.74458 9.63056 3.23463C9.53719 3.45834 9.50065 3.7185 9.48635 4.09799C9.46534 4.65568 9.17716 5.17189 8.69017 5.45093C8.20318 5.72996 7.60864 5.71954 7.11149 5.45876C6.77318 5.2813 6.52789 5.18262 6.28599 5.15102C5.75609 5.08178 5.22018 5.22429 4.79616 5.5472C4.47814 5.78938 4.24339 6.1929 3.7739 6.99993C3.30441 7.80697 3.06967 8.21048 3.01735 8.60491C2.94758 9.1308 3.09118 9.66266 3.41655 10.0835C3.56506 10.2756 3.77377 10.437 4.0977 10.639C4.57391 10.936 4.88032 11.4419 4.88029 12C4.88026 12.5581 4.57386 13.0639 4.0977 13.3608C3.77372 13.5629 3.56497 13.7244 3.41645 13.9165C3.09108 14.3373 2.94749 14.8691 3.01725 15.395C3.06957 15.7894 3.30432 16.193 3.7738 17C4.24329 17.807 4.47804 18.2106 4.79606 18.4527C5.22008 18.7756 5.75599 18.9181 6.28589 18.8489C6.52778 18.8173 6.77305 18.7186 7.11133 18.5412C7.60852 18.2804 8.2031 18.27 8.69012 18.549C9.17714 18.8281 9.46533 19.3443 9.48635 19.9021C9.50065 20.2815 9.53719 20.5417 9.63056 20.7654C9.83509 21.2554 10.2274 21.6448 10.7212 21.8478C11.0915 22 11.561 22 12.5 22C13.439 22 13.9085 22 14.2788 21.8478C14.7726 21.6448 15.1649 21.2554 15.3694 20.7654C15.4628 20.5417 15.4994 20.2815 15.5137 19.902C15.5347 19.3443 15.8228 18.8281 16.3098 18.549C16.7968 18.2699 17.3914 18.2804 17.8886 18.5412C18.2269 18.7186 18.4721 18.8172 18.714 18.8488C19.2439 18.9181 19.7798 18.7756 20.2038 18.4527C20.5219 18.2105 20.7566 17.807 21.2261 16.9999C21.6956 16.1929 21.9303 15.7894 21.9827 15.395C22.0524 14.8691 21.9088 14.3372 21.5835 13.9164C21.4349 13.7243 21.2262 13.5628 20.9022 13.3608C20.4261 13.0639 20.1197 12.558 20.1197 11.9999C20.1197 11.4418 20.4261 10.9361 20.9022 10.6392C21.2263 10.4371 21.435 10.2757 21.5836 10.0835C21.9089 9.66273 22.0525 9.13087 21.9828 8.60497C21.9304 8.21055 21.6957 7.80703 21.2262 7C20.7567 6.19297 20.522 5.78945 20.2039 5.54727C19.7799 5.22436 19.244 5.08185 18.7141 5.15109C18.4722 5.18269 18.2269 5.28136 17.8887 5.4588C17.3915 5.71959 16.7969 5.73002 16.3099 5.45096C15.8229 5.17191 15.5347 4.65566 15.5136 4.09794C15.4993 3.71848 15.4628 3.45833 15.3694 3.23463C15.1649 2.74458 14.7726 2.35523 14.2788 2.15224ZM12.5 15C14.1695 15 15.5228 13.6569 15.5228 12C15.5228 10.3431 14.1695 9 12.5 9C10.8305 9 9.47716 10.3431 9.47716 12C9.47716 13.6569 10.8305 15 12.5 15Z" fill="#1C274C"/>
											</svg>
											<label  onClick={() => setShowSubMenuProfilo(v => !v)} style={{margin:"10px 0 0 10px"}}><strong><Lang w={"impostazioni_profilo"} page={"profilo"}/></strong></label>
											{showSubMenuProfilo && (
												<ul className="submenu-profilo">
													<li  onClick={() =>{popupDisattivaProfilo()}}><Lang w={"disattiva_profilo"} page={"profilo"}/></li>
											
												</ul>
											)}
										</li>

										<li ref={sezioneNotificheRef} className="list-group-item" style={{cursor: "pointer", marginBottom:"30px"}}>
											<svg width="20px" height="20px" viewBox="0 0 32 32"><g data-name="44-Alarm"><path d="m31.89 27.55-2-4A1 1 0 0 0 29 23h-1v-8h-2v8H15v2h13.38l1 2H11v2h1.14a4 4 0 0 0 7.72 0H31a1 1 0 0 0 .89-1.45zM5 25a1 1 0 0 0 1-1v-9a10.25 10.25 0 0 1 8.18-10A1 1 0 0 0 15 4V2h2v2a1 1 0 0 0 .82 1 9.56 9.56 0 0 1 2.72.95l.93-1.77A11.54 11.54 0 0 0 19 3.2V2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.2A12.31 12.31 0 0 0 4 15v8H3a1 1 0 0 0-.89.55l-1 2 1.79.89.72-1.44z"/><path d="M9 14h2c0-3.83 2.7-4 3-4V8c-1.73 0-5 1.25-5 6zM3.297 29.292 26.299 6.29l1.414 1.414L4.711 30.706z"/></g></svg>
											<label  onClick={() => setShowSubMenuNotifiche(v => !v)} style={{margin:"10px 0 0 10px"}}><strong><Lang w={"gestione_notifiche"} page={"profilo"}/></strong></label>
											{showSubMenuNotifiche && (
												<ul className="submenu-profilo">
													{Object.keys(notifiche)
														.filter(key => typeof notifiche[key] === "boolean")
														.filter(key => key !== "email_tracking" || context.user_info.country?.toLowerCase() === "it")
														.map(key => (
															<li key={key} style={{display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0"}}>
															<span><Lang w={key} page={"profilo"}/></span>
															<label className="switch">
																<input
																type="checkbox"
																checked={notifiche[key]}
																onChange={() => handleSwitch(key)}
																/>
																<span className="slider round"></span>
															</label>
															</li>
														))}

												</ul>
											)}
										</li>
										
										
										<li className="list-group-item" style={{cursor: "pointer", marginBottom:"30px"}}>
											<svg  width="20px" height="20px" fill="#000000"  viewBox="0 0 400 400" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M199.996,0C89.719,0,0,89.72,0,200c0,110.279,89.719,200,199.996,200C310.281,400,400,310.279,400,200 C400,89.72,310.281,0,199.996,0z M199.996,373.77C104.187,373.77,26.23,295.816,26.23,200 c0-95.817,77.957-173.769,173.766-173.769c95.816,0,173.772,77.953,173.772,173.769 C373.769,295.816,295.812,373.77,199.996,373.77z"></path> <path d="M199.996,91.382c-35.176,0-63.789,28.616-63.789,63.793c0,7.243,5.871,13.115,13.113,13.115 c7.246,0,13.117-5.873,13.117-13.115c0-20.71,16.848-37.562,37.559-37.562c20.719,0,37.566,16.852,37.566,37.562 c0,20.714-16.849,37.566-37.566,37.566c-7.242,0-13.113,5.873-13.113,13.114v45.684c0,7.243,5.871,13.115,13.113,13.115 s13.117-5.872,13.117-13.115v-33.938c28.905-6.064,50.68-31.746,50.68-62.427C263.793,119.998,235.176,91.382,199.996,91.382z"></path> <path d="M200.004,273.738c-9.086,0-16.465,7.371-16.465,16.462s7.379,16.465,16.465,16.465c9.094,0,16.457-7.374,16.457-16.465 S209.098,273.738,200.004,273.738z"></path> </g> </g> </g></svg>
											<label  onClick={() => setShowSubMenuSupporto(v => !v)} style={{margin:"10px 0 0 10px"}}><strong><Lang w={"supporto"} page={"profilo"}/></strong></label>
											{showSubMenuSupporto && (
												<ul className="submenu-profilo">
													<li><Link target="_blank" to={config.servizi[domain].legal_link.faq}><Lang w={"faq"} page={"footer"}/></Link></li>
													<li><Link target="_blank" to={config.servizi[domain].legal_link.termini}><Lang w={"termini"} page={"footer"}/></Link></li>
													<li><Link target="_blank" to={config.servizi[domain].legal_link.privacy}><Lang w={"privacy"} page={"footer"}/></Link></li>
													<li><Link target="_blank" to={config.servizi[domain].legal_link.cookie}><Lang w={"cookie"} page={"footer"}/></Link></li>
													<li><Link target="_blank" to={config.servizi[domain].legal_link.contatti + queryParams}><Lang w={"contact_us"} page={"footer"}/></Link></li>
												</ul>
											)}
										</li>

										{userInfo.nextBillDate && (
										<li className="list-group-item" style={{cursor: "pointer", marginBottom:"30px"}}>
											<svg fill="#000000" height="20px" width="20px" version="1.1" id="Icon" viewBox="0 0 24 24" enable-background="new 0 0 24 24" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12,0C5.38,0,0,5.38,0,12s5.38,12,12,12s12-5.38,12-12S18.62,0,12,0z M12,22C6.49,22,2,17.51,2,12S6.49,2,12,2 s10,4.49,10,10S17.51,22,12,22z M10.5,10h3v8h-3V10z M10.5,5h3v3h-3V5z"></path> </g></svg>
											<label onClick={() => setStatoprofilo(v => !v)} style={{margin:"10px 0 0 10px"}}><strong><Lang w={"stato_profilo"} page={"profilo"}/></strong></label>
											{statoprofilo && (
												<ul className="submenu-profilo">
													<li className="list-group-item">
														<span><Lang w={"prossimo_addebito"} page={"profilo"}/>: </span>
														<span>{helpers.rendiDataLeggibile(userInfo.nextBillDate)}</span>
													</li>
												</ul>
											)}
										</li>)}

										{userInfo.paylog && userInfo.paylog.length > 0 && (
											<li className="list-group-item" style={{cursor: "pointer", marginBottom:"30px"}}>
											<svg fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 60 60">
											<path d="M11.68,13l-0.833-5h-2.99C7.411,6.28,5.859,5,4,5C1.794,5,0,6.794,0,9s1.794,4,4,4c1.859,0,3.411-1.28,3.858-3h1.294l0.5,3
												H9.614l5.171,26.016c-2.465,0.188-4.518,2.086-4.76,4.474c-0.142,1.405,0.32,2.812,1.268,3.858C12.242,48.397,13.594,49,15,49h2
												c0,3.309,2.691,6,6,6s6-2.691,6-6h11c0,3.309,2.691,6,6,6s6-2.691,6-6h4c0.553,0,1-0.447,1-1s-0.447-1-1-1h-4.35
												c-0.826-2.327-3.043-4-5.65-4s-4.824,1.673-5.65,4h-11.7c-0.826-2.327-3.043-4-5.65-4s-4.824,1.673-5.65,4H15
												c-0.842,0-1.652-0.362-2.224-0.993c-0.577-0.639-0.848-1.461-0.761-2.316c0.152-1.509,1.546-2.69,3.173-2.69h0.791
												c0.014,0,0.025,0,0.039,0h38.994C57.763,41,60,38.763,60,36.013V13H11.68z M4,11c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2
												S5.103,11,4,11z M46,45c2.206,0,4,1.794,4,4s-1.794,4-4,4s-4-1.794-4-4S43.794,45,46,45z M23,45c2.206,0,4,1.794,4,4s-1.794,4-4,4
												s-4-1.794-4-4S20.794,45,23,45z M58,36.013C58,37.66,56.66,39,55.013,39H16.821l-4.77-24H58V36.013z"/>
											</svg>
											<label  onClick={() => setShowSubMenuRicevute(v => !v)} style={{margin:"10px 0 0 10px"}}><strong><Lang w={"ricevute_acquisti"} page={"profilo"}/></strong></label>
											{showSubMenuRicevute && (<>
												
												<ul className="submenu-profilo">
													{userInfo.paylog.map((el, index) => (
														<li key={index} className="list-group-item">
															<Link onClick={() =>{scaricaRicevuta(el.chargeId)}}>
																{el.prezzo}{el.valuta ? el.valuta : '€'} - {helpers.rendiDataLeggibile(el.dataTransazione)}
																{scaricaLoading && (
																	<span style={{marginLeft:8}}>
																		<i className="fa fa-spinner fa-spin"></i> {/* FontAwesome spinner */}
																	</span>
																)}
															</Link>
														</li>
													))}
												</ul>
											</>)}
										
											</li>
										)}
										
									
										
										
										<input type="submit" value={salva}></input>
										{context.premiumLevel > 1 && (
										<p className="scrittaBottone" onClick={(e)=>showPopup()}><Lang w={"disiscrizione"} page={"profilo"}/></p>
										)}
									</ul>
								<div class="col-12"></div>
							</div>
						</div>
					</div>	
				</div>
				</form>
				{uploadLoading && <Spinner />}
			<PopopGenerico
						show={modalShow}
						onHide={() => setModalShow(false)}
						onUnsub={()=> unsub()}
						onDisattivaProfilo={()=> disattivaProfilo()}
						provenienza={provenienza}
						contenuto={contenuto}
						
			/>

			</div>);

}
